// Mock data for bornfromshine e-commerce

export const categories = [
  { id: 'all', name: 'ALL', slug: 'all' },
  { id: 'outerwear', name: 'OUTERWEAR', slug: 'outerwear' },
  { id: 'tops', name: 'TOPS', slug: 'tops' },
  { id: 'bottoms', name: 'BOTTOMS', slug: 'bottoms' },
  { id: 'accessories', name: 'ACCESSORIES', slug: 'accessories' },
];

export const products = [
  {
    id: '1',
    name: 'OVERSIZED COAT',
    category: 'outerwear',
    price: 2400,
    description: 'Structured oversized coat with dramatic silhouette. Premium wool blend construction.',
    colorBlock: '#000000',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    inStock: true,
    featured: true,
  },
  {
    id: '2',
    name: 'DECONSTRUCTED BLAZER',
    category: 'outerwear',
    price: 1800,
    description: 'Asymmetric blazer with raw edges and architectural design.',
    colorBlock: '#1a1a1a',
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    featured: true,
  },
  {
    id: '3',
    name: 'MINIMAL TEE',
    category: 'tops',
    price: 450,
    description: 'Essential oversized cotton tee. Heavyweight fabric with dropped shoulders.',
    colorBlock: '#ffffff',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    inStock: true,
    featured: false,
  },
  {
    id: '4',
    name: 'ASYMMETRIC SHIRT',
    category: 'tops',
    price: 890,
    description: 'Architectural shirt with asymmetric hemline. Contemporary fit.',
    colorBlock: '#f5f5f5',
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    featured: true,
  },
  {
    id: '5',
    name: 'WIDE LEG TROUSERS',
    category: 'bottoms',
    price: 1200,
    description: 'Dramatic wide-leg trousers with high waist. Flowing silhouette.',
    colorBlock: '#2d2d2d',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    inStock: true,
    featured: false,
  },
  {
    id: '6',
    name: 'CARGO PANTS',
    category: 'bottoms',
    price: 980,
    description: 'Utility-inspired cargo pants with oversized pockets.',
    colorBlock: '#0a0a0a',
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    featured: true,
  },
  {
    id: '7',
    name: 'LEATHER TOTE',
    category: 'accessories',
    price: 1600,
    description: 'Minimalist leather tote with structured design. Premium Italian leather.',
    colorBlock: '#000000',
    sizes: ['ONE SIZE'],
    inStock: true,
    featured: false,
  },
  {
    id: '8',
    name: 'STATEMENT BELT',
    category: 'accessories',
    price: 420,
    description: 'Bold hardware belt with signature branding.',
    colorBlock: '#silver',
    sizes: ['S', 'M', 'L'],
    inStock: true,
    featured: false,
  },
  {
    id: '9',
    name: 'BOMBER JACKET',
    category: 'outerwear',
    price: 2100,
    description: 'Contemporary bomber with exaggerated proportions.',
    colorBlock: '#141414',
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: false,
    featured: false,
  },
  {
    id: '10',
    name: 'GRAPHIC TEE',
    category: 'tops',
    price: 520,
    description: 'Bold graphic print on premium cotton.',
    colorBlock: '#ffffff',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    inStock: true,
    featured: false,
  },
  {
    id: '11',
    name: 'TRACK PANTS',
    category: 'bottoms',
    price: 780,
    description: 'Athletic-inspired track pants with tapered fit.',
    colorBlock: '#1f1f1f',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    inStock: true,
    featured: false,
  },
  {
    id: '12',
    name: 'MINIMAL BACKPACK',
    category: 'accessories',
    price: 890,
    description: 'Sleek minimalist backpack with multiple compartments.',
    colorBlock: '#000000',
    sizes: ['ONE SIZE'],
    inStock: true,
    featured: true,
  },
];

export const mockUser = {
  id: 'user-1',
  email: 'demo@bornfromshine.com',
  name: 'Demo User',
  orders: [],
};

export const mockCart = [];
